import { render, staticRenderFns } from "./Epice.vue?vue&type=template&id=c08d7076&scoped=true&"
import script from "./Epice.vue?vue&type=script&lang=js&"
export * from "./Epice.vue?vue&type=script&lang=js&"
import style0 from "./Epice.vue?vue&type=style&index=0&id=c08d7076&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c08d7076",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
